import { CollectionsEnum } from "../../../lib/enums"
import { FC, useState } from "react"
import { useInventoryContext } from "../../../hooks/use-inventory"
import { UnitDialog } from "./unit-dialog"
import { UnitCardList } from "../../../components/molecules/unit-card-list"

type UnitsProps = {}

export const Units: FC<UnitsProps> = () => {
  const { units, bins } = useInventoryContext()
  const [showUnitForm, setShowUnitForm] = useState(false)
  const [editItemId, setEditItemId] = useState("")

  const handleEditUnit = (unitId: string) => {
    setEditItemId(unitId)
    setShowUnitForm(true)
  }

  const handleAddUnit = () => {
    setEditItemId("")
    setShowUnitForm(true)
  }

  return (
    <>
      <UnitCardList
        units={units}
        bins={bins}
        onEditUnit={handleEditUnit}
        onAddUnit={handleAddUnit}
      />

      <UnitDialog
        isShowing={showUnitForm}
        close={() => {
          setShowUnitForm(false)
          setEditItemId("")
        }}
        editItemId={editItemId}
      />
    </>
  )
}
